




















import { Vue, Component } from 'vue-property-decorator'
import { mapActions } from 'vuex'

type VRule = ((v: any) => true | string)

@Component({
  components: {},
  methods: {
    ...mapActions(['sendContactEmail'])
  }
})
export default class ContactView extends Vue {
  valid = true;
  name = '';
  nameRules: VRule[] = [
    v => !!v || 'Name is required',
    v => (v && v.length <= 10) || 'Name must be less than 10 characters'
  ];

  email = '';
  emailRules: VRule[] = [
    v => !!v || 'E-mail is required',
    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
  ];

  subject = '';
  subjectRules: VRule[] = [
    v => !!v || 'Subject is required',
    v => (v && v.length <= 60) || 'Subject must be less than 60 characters'
  ];

  message = '';
  messageRules: VRule[] = [
    v => !!v || 'message is required',
    v => (v && v.length <= 1000) || 'Message must be less than 1000 characters'
  ];

  showAlert = false;
  alertMessage = '';
  alertType = 'success';

  validate () {
    // @ts-ignore
    if (this.$refs.form.validate()) {
      this.contactSupport()
    }
  }

  async contactSupport () {
    this.showAlert = false
    // @ts-ignore
    const result = await this.sendContactEmail({
      name: this.name,
      email: this.email,
      subject: this.subject,
      message: this.message
    })
    if (result === true) {
      this.showAlert = true
      this.alertMessage = 'sent.'
      this.alertType = 'success'
      // @ts-ignore
      this.$refs.form.reset()
    } else {
      this.showAlert = true
      this.alertMessage = result.message
      this.alertType = 'error'
    }
  }
}
